module.exports = __webpack_public_path__ + "static/little-girl-jumping-fd9dbc44181534cb4b09a42df120e7c6.mp4";